import { EvaChartStates } from "types/factory";

import { computeYAxisLocks } from "./mpcLocks";
import { convertToNumber } from "./utils/convertToNumber";

export function totalRateCumLocks(states: Partial<EvaChartStates>) {
  const { locks, product, series } = states;
  const lockedXMin = locks?.xMin?.value;
  const lockedXMax = locks?.xMax?.value;

  const { lockedYMin, lockedYMax, lockedYMinType, lockedYMaxType } = computeYAxisLocks(
    locks?.yMin,
    locks?.yMax,
    product,
    series
  );

  return {
    lockedXMin: convertToNumber(lockedXMin),
    lockedXMax: convertToNumber(lockedXMax),
    lockedYMin,
    lockedYMax,
    lockedYMinType,
    lockedYMaxType
  };
}
